import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom-v5';

export const usePaygRouteParams = () => {
  const { search, pathname } = useLocation();
  const history = useHistory();

  return useMemo(() => {
    const searchParams = new URLSearchParams(search);
    return {
      topupSessionId: searchParams.get('topupSessionId') || undefined,
      hasSuccessfulPayment: searchParams.get('success') === 'true',
      clearRouteParams: () => history.replace(pathname),
    };
  }, [search, history, pathname]);
};
